module.exports = __webpack_public_path__ + "549e09b342dd33e0765f75c6124bae03.png";